import React from 'react'
import _ from 'lodash'

import {MessageStore} from 'api/message'

import {Table, AddressEncoder} from 'ui'
import {SortTypes, LinkCell, DateTimeCell} from 'ui/Table.jsx'
import {BufferCell} from './BufferCell.jsx'

export class QueryTable extends React.Component {
   static get propTypes() {
      return {
         query:        React.PropTypes.object.isRequired,
         setParameter: React.PropTypes.func.isRequired,
         redraw:       React.PropTypes.any
      }
   }

   constructor() {
      super()

      this.onSortChange = this.onSortChange.bind(this)
      this.colDef = this.colDef.bind(this)
   }

   componentWillMount() {
      this._mounted = true

      MessageStore.addChangeListener(
         (this._changeListener = () => {
            if (this._mounted) {
               this.setState(state => state)
            }
         })
      )
   }

   componentWillUnmount() {
      this._mounted = false

      MessageStore.removeChangeListener(this._changeListener)
   }

   onSortChange(field, direction) {
      MessageStore.sort(field, direction)
   }

   colDef(field) {
      const encoding = _.get(this.props, 'query._opts.data-encoding', 'base64'),
         format = _.get(this.props, 'query._opts.bufferFmt', 'ascii')

      switch (field) {
         case 'datetime':
            return {
               field,
               name:     'Datetime',
               visible:  true,
               cell:     DateTimeCell,
               relative: false
            }
         case 'received':
            return {
               field,
               name:     'Received',
               visible:  true,
               cell:     DateTimeCell,
               relative: false
            }
         case 'network':
            return {
               field,
               name:      'Network',
               visible:   true,
               cell:      LinkCell,
               transform: network =>
                  _.isObject(network) ? _.get(network, 'name', network.key) : network,
               link: ({network}) => `/dashboard/network/${network.key}/overview`
            }
         case 'device':
            return {
               field,
               name:      'Device',
               visible:   true,
               cell:      LinkCell,
               transform: device =>
                  _.isObject(device) ? _.get(device, 'name', device.key) : device,
               link: ({network, device}) => `/dashboard/device/${network.key}/${device.key}`
            }

         case 'proto/tm.uid':
            return {
               field,
               name:      'Unique ID',
               visible:   true,
               transform: AddressEncoder.encode
            }

         case 'proto/tm.sid':
            return {
               field,
               name:      'System ID',
               visible:   true,
               transform: AddressEncoder.encode
            }

         case 'proto/tm.nid':
            return {
               field,
               name:      'Network ID',
               visible:   true,
               transform: AddressEncoder.encode
            }

         case 'proto/tm.address':
            return {
               field,
               name:      'Address',
               visible:   true,
               transform: AddressEncoder.encode
            }

         case 'proto/tm.data':
            return {
               field,
               name:    'Data',
               visible: true,
               getCell: ({row}) => {
                  if ('serial' === row['proto/tm'].detail || 'serial' === row['proto/tm'].command) {
                     return props => <BufferCell encoding={encoding} format={format} {...props} />
                  }

                  return null
               }
            }

         default:
            return {field, name: field, visible: true}
      }
   }

   render() {
      const {sorting} = ['datetime', SortTypes.DEFAULT],
         {setParameter, redraw} = this.props,
         {columns} = this.props.query,
         colarray = (columns || '').split(','),
         colMap = _.map(colarray, this.colDef)

      return (
         <Table
            rows={MessageStore.messages}
            columns={colMap}
            onToggleColumn={column => setParameter('columns', _.without(colarray, column))}
            redraw={redraw}
            onSortChange={this.onSortChange}
            sorting={sorting}
         />
      )
   }
}



// WEBPACK FOOTER //
// lib/bundle/dashboard/query/QueryTable.jsx